import { translate } from '@/utils/translation';

/**
 * A validator function that checks if the length of a given value does not exceed a specified maximum length.
 *
 * @function
 * @name maxLength
 * @param {number} maxLength - The maximum allowed length.
 * @returns {Function} - A function that takes a value (string or array) and returns true if the value's length is less than or equal to the specified maximum length, or an error message if the length is exceeded.
 */
export function maxLength(maxLength: number) {
  return (value: string | any[]) => {
    return value?.length <= maxLength || translate('max_length_exceeded');
  };
}
